import * as types from './constants';
import initialState from './initialState';

export default(state = initialState, action) => {
    switch (action.type) {
        case types.NOTIFY_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}